import { Form, FormInstance } from 'antd';
import { RegistrationForm } from './components/RegistrationForm';
import { StepsNavigation } from './components/StepsNavigation';
import { Block1 } from './components/subjectBlocks/Block1';
import { Block2 } from './components/subjectBlocks/Block2';
import { Block5 } from './components/subjectBlocks/Block5';
import { Block7 } from './components/subjectBlocks/Block7';
import { Block31 } from './components/subjectBlocks/Block31';
import { Block32 } from './components/subjectBlocks/Block32';
import { Block33 } from './components/subjectBlocks/Block33';
import { Block41 } from './components/subjectBlocks/Block41';
import { Block42 } from './components/subjectBlocks/Block42';
import { Block61 } from './components/subjectBlocks/Block61';
import { Block62 } from './components/subjectBlocks/Block62';
import { PreviewDocument } from './components/subjectBlocks/PreviewDocument';
import {
  CompWithStepsProps,
  FormDataArgs,
  formInitialValues,
} from './constants/constants';
import { downloadJson } from './functions/downloadJson';
import { filledFormData } from './functions/formDataMock';

type FormContentProps = {
  specNeedsSubGroupOptions: string[];
  specNeedsSpecificOptions: string[];
  specNeedsSubSpecificOptions: string[];
  onValuesChange: (changedValues: any, form: FormInstance) => void;
} & CompWithStepsProps;

export const FormContent = ({
  form,
  currentStep,
  setCurrentStep,
  specNeedsSubGroupOptions,
  specNeedsSpecificOptions,
  specNeedsSubSpecificOptions,
  onValuesChange,
}: FormContentProps) => {
  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={downloadJson}
      initialValues={
        window.location.hostname === 'localhost'
          ? filledFormData
          : formInitialValues
      }
      onValuesChange={(changedValues, values) => {
        onValuesChange(changedValues, form);
      }}
    >
      <RegistrationForm
        form={form}
        currentStep={currentStep}
        specNeedsSubGroupOptions={specNeedsSubGroupOptions}
        specNeedsSpecificOptions={specNeedsSpecificOptions}
        specNeedsSubSpecificOptions={specNeedsSubSpecificOptions}
      />
      <Block1 form={form} currentStep={currentStep} />
      <Block2 form={form} currentStep={currentStep} />
      <Block31 form={form} currentStep={currentStep} />
      <Block32 form={form} currentStep={currentStep} />
      <Block33 form={form} currentStep={currentStep} />
      <Block41 form={form} currentStep={currentStep} />
      <Block42 form={form} currentStep={currentStep} />
      <Block5 form={form} currentStep={currentStep} />
      <Block61 form={form} currentStep={currentStep} />
      <Block62 form={form} currentStep={currentStep} />
      <Block7 form={form} currentStep={currentStep} />
      <PreviewDocument form={form} currentStep={currentStep} />
      <StepsNavigation
        form={form}
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
      />
    </Form>
  );
};
